<template>
  <div class="view-contanier">
    <div class="header">
      <div class="tab">
        <span
          v-for="(item, $index) in tabList"
          :key="item.permissson"
          v-permissson="`${item.permissson}`"
          :class="['tabItem', active === $index ? 'active' : '']"
          @click="changeType($index, item.permissson)"
        >
          {{ item.name }}
          ({{
            item.type === 10000 ? listTotal : tabTotal
          }})
        </span>
      </div>
      <div class="opt">
        <div class="search">
          <el-popover
            ref="popover"
            placement="top"
            class="searchPop"
            title="批量搜索"
            trigger="click"
            width="378"
          >
            <div class="close" @click="closeSearchPanel">
              <i class="el-icon-close"></i>
            </div>
            <base-muti-input
              ref="baseMutiInput"
              v-model="referenceNumber"
              :default="referenceNumber"
            ></base-muti-input>
            <div style="text-align: right; margin: 16px 0 0">
              <el-button size="small" @click="handleEmpty">清空</el-button>
              <div
                class="sure"
                @mousedown="handleConfirm"
              >确定</div
              >
            </div>
          </el-popover>
          <el-input
            :value="filterList.numbers"
            placeholder="请输入提单号/账单号/柜号搜索"
            class="input-search"
            @focus="handleFocus"
          ></el-input>
          <div class="btn-search" @click="handleConfirm">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <!-- <div
          v-for="(item, $index) in recognitionList"
          v-show="active === $index"
          :key="item"
          v-permissson="`${item}`"
          class="recognition flex_c_c"
          @click="dialogVisible2 = true"
        >
          <img src="@/assets/images/const/recognition.png" alt="" />
          供应商账单自动识别
        </div> -->
        <div
          v-show="computedPermissions('导出')"
          v-if="[10000, 1, 2, 3].indexOf(tabActive) > -1"
          :v-permissson="computedPermissions('导出')"
          class="derive_a flex_c_c"
          @click="exportOrigin"
        >
          <img src="@/assets/images/bill/import.png" alt="" />
          导出
        </div>
        <!-- <div
          v-show="computedPermissions('新增一般账单')"
          v-if="[10000, 1, 2, 3].indexOf(tabActive) > -1"
          :v-permissson="computedPermissions('新增一般账单')"
          class="add flex_c_c"
          @click="(dialogVisible3 = true), (dialogType = 1)"
        >
          <img src="@/assets/images/const/add.png" alt="" />
          新增一般账单
        </div> -->
        <div
          v-show="computedPermissions('生成账单')"
          v-if="tabActive === 2"
          :v-permissson="computedPermissions('生成账单')"
          class="add flex_c_c"
          style="width: 100px;"
          @click="dialogVisible8 = true"
        >
          生成账单
        </div>
        <div
          class="derive_a flex_c_c"
          style="padding: 0 12px"
          @click="dialogVisible9 = true"
        >
          自定义列表
        </div>
        <el-upload
          class="upload-demo"
          action="/api/Payable/importPayableValidate?type=0"
          :headers="headers"
          :on-success="handleSuccess"
          :on-error="handleError"
          :file-list="fileList"
          :show-file-list="false"
        >
          <div
            class="derive_a flex_c_c"
            style="width: 100px;"
          >
            <img src="@/assets/images/bill/upload.png" alt="" />
            导入模板
          </div>
        </el-upload>
        <div
          class="derive_a flex_c_c"
          style="width: 100px;"
          @click="donwloadFile"
        >
          <img src="@/assets/images/bill/import.png" alt="" />
          下载模板
        </div>

        <!-- <div
          v-for="(item, $index) in addList"
          v-show="active === $index"
          :key="item"
          v-permissson="`${item}`"
          class="add flex_c_c"
          @click="(dialogVisible3 = true), (dialogType = 0)"
        >
          <img src="@/assets/images/const/add.png" alt="" />
          新增分摊账单
        </div> -->
        <BaseFilter
          :isActive="isActive"
          :width="494"
          :isEmptyBorder="true"
          @sendFilter="sendFilter"
          @reset="reset"
        >
          <div class="filter">
            <SelectFilter
              ref="selectFilter"
              :filterListJson="filterListJson"
              :filterListId="filterListId"
              :companyDrapdown="companyDrapdown"
              :pickUpOptions="pickUpOptions"
              :clearenceOptions="clearenceOptions"
              :originOptions="originOptions"
              :destinationOptions="destinationOptions"
              :supplierOptions="supplierOptions"
              :userOptions="userOptions"
              :tableCode="tableCode"
              @ok="getFilter()"
            ></SelectFilter>
            <!-- <el-form ref="form" :model="filterList" label-width="104px">
              <el-form-item label="创建时间">
                <el-date-picker
                  v-model="filterList.createDate"
                  style="width: 320px"
                  type="daterange"
                  range-separator="至"
                  align="center"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  unlink-panels
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="业务员">
                <el-select
                  v-model="filterList.saleIds"
                  style="width: 320px"
                  filterable
                  placeholder="请选择"
                  multiple
                >
                  <el-option
                    v-for="item in userOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户">
                <el-select
                  v-model="filterList.companyIds"
                  style="width: 320px"
                  placeholder="请选择类型"
                  multiple
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in companyDrapdown"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="供应商">
                <el-select
                  v-model="filterList.supplierId"
                  style="width: 320px"
                  multiple
                  clearable
                  filterable
                  placeholder="请选择供应商"
                >
                  <el-option
                    v-for="item in supplierOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form> -->
          </div>
          <!-- <div slot="customsBtn" class="filter-detail flex_c_c" @click="dialogVisible6 = true">
            筛选详情
          </div> -->
        </BaseFilter>
      </div>
    </div>
    <div class="data">
      <el-tabs v-model="tabActive" v-loading="loading" type="border-card" class="el-tabs" @tab-click="initList()">
        <template v-if="active">
          <el-tab-pane
            v-for="item in childTabList"
            :key="item.type"
            :label="`${item.name}(${
              item.type === 10000
                ? tabTotal
                : tabNumer.find((a) => a.type === item.type - 1)?.qty || 0})`"
            :name="item.type"> </el-tab-pane>
        </template>
        <BaseTable
          v-if="height !== 0"
          :key="active"
          :height="height"
          :tableData="{
            ...tableData,
            fileds,
          }"
          :pageIndex="pager.pageIndex"
          :pageSize="pager.pageSize"
          :loading="loading"
          :pageSizes="[20, 30, 50, 100]"
          :isEmptyBorder="true"
          @handlePageChange="handlePageChange"
          @handleSelectionChange="handleSelectionChange"
          @sortChange="sortChange"
          @dblclick="dblclick"
        >
          <template slot="blNo" slot-scope="row">
            {{ row.scope.blNo }}
            <img
              v-if="!row.scope.invoiceType"
              style="cursor: pointer"
              src="@/assets/images/const/viewBill.png"
              title="跟进记录"
              @click="viewlog(row.scope)"
            />
          </template>
          <template slot="status" slot-scope="row">
            <div v-if="row.scope.status === 0" class="status status1">
              {{ row.scope.statusName }}
            </div>
            <div v-else-if="row.scope.status === 5" class="status status2">
              {{ row.scope.statusName }}
            </div>
            <div v-else class="status status3">{{ row.scope.statusName }}</div>
          </template>
          <template slot="defrayStatusName" slot-scope="row">
            <div v-if="row.scope.defrayStatus === 0" class="status status1">
              {{ row.scope.defrayStatusName }}
            </div>
            <div v-else-if="row.scope.defrayStatus === 1" class="status status2">
              {{ row.scope.defrayStatusName }}
            </div>
            <div v-else class="status status3">
              {{ row.scope.defrayStatusName }}
            </div>
          </template>
          <template slot="opt" slot-scope="row">
            <el-popover
              v-show="active === 0"
              :ref="`popover${row.scope.id}`"
              placement="bottom-start"
              popper-class="pop-table-opt"
              width="114"
              trigger="click"
            >
              <div class="table-opt">
                <div>
                  <span
                    class="opt-item"
                    @click="detail(row.scope)"
                  >录入</span
                  >
                </div>
              </div>
              <img
                slot="reference"
                style="margin-left: -14px"
                src="@/assets/images/table/opt.png"
              />
            </el-popover>
          </template>
          <template slot="clearenceType" slot-scope="row">
            <p style="display: flex; justify-content: space-between">
              <span>
                <span
                  class="clearenceType"
                  :class="`clearenceType${row.scope.clearenceType}`"
                >{{
                  config.clearenceTypeOptions.find(
                    (a) => a.value === row.scope.clearenceType
                  ).label
                }}
                </span>
                <span v-if="row.scope.clearenceSupplier" class="supplier">{{
                  row.scope.clearenceSupplier
                }}</span>
              </span>
            </p>
          </template>
          <template slot="pickUpType" slot-scope="row">
            <p style="display: flex; justify-content: space-between">
              <span>
                <span
                  class="pickUpType"
                  :class="`pickUpType${row.scope.pickUpType}`"
                >{{
                  config.pickUpTypeOptions.find(
                    (a) => a.value === row.scope.pickUpType
                  ).label
                }}
                </span>
                <span v-if="row.scope.pickUpSupplier" class="supplier">{{
                  row.scope.pickUpSupplier
                }}</span>
              </span>
            </p>
          </template>
          <template #custom-total>
            <div class="custom-total">
              <div style="display: flex">
                <div class="select">已选 {{ selectionItem.length }} 项</div>
                <div v-if="active === 0" class="total">
                  应付合计：<span>{{ totalAmount }} USD</span>
                </div>
                <div
                  v-if="selectionItem.length && active === 0"
                  class="total"
                  v-html="totalHtml"
                ></div>
                <div
                  v-if=" active"
                  class="total"
                >
                  总金额
                  <span style="color: #fe453d;font-weight: bold;line-height: 40px;"> {{ tabTotalAmount.totalAmount }}</span>
                  <template v-if="tabActive > 3 && tabActive !== 10000">
                    &nbsp;&nbsp;&nbsp;&nbsp;核销金额合计：
                    <span style="color: #fe453d;font-weight: bold;line-height: 40px;"> {{ tabTotalAmount.verifedAmount }}</span>
                  </template>
                </div>
                <div v-if="tabActive === 1" class="batchCounterAudit flex_c_c" @click="handleBatch">
                  <img src="@/assets/images/const/batchCounterAudit.png">
                  批量审核
                </div>
                <div v-if="tabActive === 1" class="batchCounterAudit flex_c_c" @click="batchDeleteRow">
                  <img src="@/assets/images/const/batchCounterAudit.png">
                  批量删除
                </div>
                <div
                  v-if="tabActive === 2"
                  class="batchCounterAudit flex_c_c"
                  @click="counteraudit"
                >
                  <img src="@/assets/images/const/batchCounterAudit.png">
                  批量反审核
                </div>
              <!-- <div
                v-if="active === 2"
                class="batchCounterAudit flex_c_c"
                @click="batchCounterAudit(true)"
              >
                <img src="@/assets/images/const/batchCounterAudit.png">
                批量完成
              </div>
              <div
                v-if="active === 3"
                class="batchCounterAudit flex_c_c"
                @click="batchCounterAudit(false)"
              >
                <img src="@/assets/images/const/batchCounterAudit.png">
                批量取消完成
              </div> -->
              </div>
            </div>
          </template>
        </BaseTable>
      </el-tabs>
    </div>
    <!-- <BillRecognitionDialog
      :dialogVisible="dialogVisible2"
      @cancel="dialogVisible2 = false"
    ></BillRecognitionDialog> -->
    <AddBillDialog
      :dialogVisible="dialogVisible3"
      :dialogType="dialogType"
      @cancel="dialogVisible3 = false"
      @ok="ok"
    ></AddBillDialog>
    <CopeWithDetailDialog
      :dialogVisible="dialogVisible4"
      :rowData="rowData"
      @cancel="dialogVisible4 = false"
      @ok="ok2"
    ></CopeWithDetailDialog>
    <SupplierRecognitionDialog
      :dialogVisible="dialogVisible2"
      @cancel="dialogVisible2 = false"
    ></SupplierRecognitionDialog>
    <ExportCopeWith
      :dialogVisible="dialogVisible5"
      :filter="{
        ...formatterFilter(),
        status: active === 0 || tabActive === 10000 ? undefined : +tabActive - 1
      }"
      @cancel="dialogVisible5 = false"
    >
    </ExportCopeWith>
    <FilterDetailDialog
      :dialogVisible="dialogVisible6"
      :filter="{
        ...formatterFilter(),
        status: active === 0 || tabActive === 10000 ? undefined : +tabActive - 1
      }"
      @cancel="dialogVisible6 = false"
    ></FilterDetailDialog>
    <follow-up-records-drawer
      :drawer="drawer"
      :rowData="{
        ...rowData,
        id: rowData.mblId,
        status: 4,
      }"
      :bill-type="1"
      @close="drawer = false"
    ></follow-up-records-drawer>
    <UploadFileCheckDataDialog
      :dialogVisible="dialogVisible7"
      :fileData="fileData"
      :type="1"
      @cancel="dialogVisible7 = false"
      @ok="dialogVisible7 = false; getList(pager)"
    ></UploadFileCheckDataDialog>
    <CreateBillDialog
      :dialogVisible="dialogVisible8"
      :type="1"
      :filterList="{
        ...formatterFilter(),
        status: active === 0 || tabActive === 10000 ? undefined : +tabActive - 1
      }"
      @cancel="dialogVisible8 = false"
      @ok="dialogVisible8 = false; getList(pager)"
    ></CreateBillDialog>
    <CustomerListDialog
      :dialogVisible="dialogVisible9"
      :useFildList="useFildListForTab"
      :useLogId="useLogId"
      :tabCode="tabCode"
      :tableCode="tableCode"
      @ok="
        dialogVisible9 = false;
        getUserUseLog();
      "
      @cancel="dialogVisible9 = false"
    ></CustomerListDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseFilter = () => import('@/components/filter/BaseFilter')
const BaseMutiInput = () => import('@/components/base/BaseMutiInput.vue')
// import BillRecognitionDialog from './components/BillRecognitionDialog'
import AddBillDialog from './components/AddBillDialog'
import CopeWithDetailDialog from './components/CopeWithDetailDialog'
import ExportCopeWith from './components/ExportCopeWith'
import SupplierRecognitionDialog from './components/SupplierRecognitionDialog'
import UploadFileCheckDataDialog from './components/UploadFileCheckDataDialog'
import FilterDetailDialog from './components/FilterDetailDialog'
import CreateBillDialog from './components/CreateBillDialog'
const SelectFilter = () => import('@/components/filter/SelectFilter')

import { permissions, derive } from '@/utils/common'
import { getSupplierDropDownList, getSaleList, getSysTableUser } from '@/api/system'
import Decimal from 'decimal.js'
const FollowUpRecordsDrawer = () =>
  import('@/components/drawer/FollowUpRecordsDrawer')
const CustomerListDialog = () =>
  import('@/components/dialog/CustomerListDialog.vue')
import {
  getPayablePages,
  getPayablePages1,
  reviewedPayableInvoice,
  // deletePayableInvoice,
  deletePayable,
  reviewedPayable,
  // repeatReviewedPayableInvoice,
  // reviewedPayableInvoiceBatch,
  batchRepeatReviewedPayable,
  completePayable
  // batchRepeatReviewedPayableInvoice
} from '@/api/fee'
import { myMixins } from '@/mixins'
import { mapGetters } from 'vuex'
import config from '@/utils/config'
export default {
  name: 'CopeWith',
  components: {
    BaseTable,
    BaseFilter,
    BaseMutiInput,
    // BillRecognitionDialog,
    AddBillDialog,
    CopeWithDetailDialog,
    SupplierRecognitionDialog,
    ExportCopeWith,
    FilterDetailDialog,
    FollowUpRecordsDrawer,
    UploadFileCheckDataDialog,
    CreateBillDialog,
    SelectFilter,
    CustomerListDialog
  },
  mixins: [myMixins],
  data() {
    return {
      config,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      active: 0,
      tabActive: 10000,
      tableData: {
        // 件数、垂量、材识、目的港、收赏进口商、销售员、税金、应收、应付合计、利润合计、已核销金额、未付金额

        fileds: [
          {
            filed: 'companyName',
            label: '客户',
            align: 'left',
            width: '210'
          },
          {
            filed: 'mblNo',
            label: '主提单号',
            width: '200',
            isCopy: true,
            align: 'left'
          },
          {
            filed: 'blNo',
            label: '分提单号',
            width: '200',
            isCopy: true,
            isCustom: true,
            align: 'left'
          },
          {
            filed: 'containerNumber',
            label: '柜号',
            width: '140',
            align: 'left',
            isCopy: true
          },
          {
            filed: 'statusName',
            label: '应付状态',
            align: 'left',
            width: '80'
          },
          {
            filed: 'supplieName',
            label: '供应商类型',
            align: 'left',
            width: '90'
          },
          {
            filed: 'eta',
            label: 'ETA',
            width: '100',
            align: 'left',
            formatter: (row) => {
              return row.eta ? row.eta.slice(0, row.eta.length - 9) : ''
            },
            isSort: true
          },
          {
            filed: 'ata',
            label: 'ATA',
            width: '100',
            align: 'left',
            formatter: (row) => {
              return row.ata ? row.ata.slice(0, row.ata.length - 9) : ''
            },
            isSort: true
          },
          {
            filed: 'releaseDate',
            label: '放行日期',
            width: '100',
            align: 'left',
            formatter: (row) => {
              return row.releaseDate ? row.releaseDate.slice(0, row.releaseDate.length - 9) : ''
            },
            isSort: true
          },
          {
            filed: 'emptyReturnedDate',
            label: '还空日期',
            width: '100',
            align: 'left',
            formatter: (row) => {
              return row.emptyReturnedDate ? row.emptyReturnedDate.slice(0, row.emptyReturnedDate.length - 9) : ''
            },
            isSort: true
          },
          {
            filed: 'dischargeDate',
            label: '卸船日期',
            width: '100',
            align: 'left',
            formatter: (row) => {
              return row.dischargeDate ? row.dischargeDate.slice(0, row.dischargeDate.length - 9) : ''
            },
            isSort: true
          },
          {
            filed: 'finishDate',
            label: '完结日期',
            width: '100',
            align: 'left',
            formatter: (row) => {
              return row.finishDate ? row.finishDate.slice(0, row.finishDate.length - 9) : ''
            },
            isSort: true
          },
          {
            filed: 'picPickUpDate',
            label: '提柜时间',
            width: '160',
            formatter: (row) =>
              row.picPickUpDate
                ? row.picPickUpDate.slice(0, row.picPickUpDate.length - 9)
                : ''
          },
          {
            filed: 'firstDepartureDate',
            label: '出库时间',
            width: '160',
            formatter: (row) =>
              row.firstDepartureDate
                ? row.firstDepartureDate.slice(0, row.firstDepartureDate.length - 9)
                : ''
          },
          {
            filed: 'directCode',
            label: '直送仓库',
            width: '150'
          },
          {
            filed: 'isHold',
            label: '是否查验',
            width: '150',
            formatter: row => {
              return row.isHold ? '是' : '否'
            }
          },
          {
            filed: 'mblStatus',
            label: '提单状态',
            width: '150',
            formatter: (row) => {
              const obj = {
                0: '未完结',
                1: '未完结',
                3: '已完结',
                4: '已完结'
              }
              return obj[row.mblStatus] || '未完结'
            }
          },
          {
            filed: 'mblTypeName',
            label: '提单类型',
            align: 'left',
            width: '80'
          },
          {
            filed: 'clearenceType',
            label: '清关方式',
            align: 'left',
            width: '200',
            isCustom: true
          },
          {
            filed: 'pickUpType',
            label: '提货方式',
            width: '200',
            isCustom: true
          },
          {
            filed: 'destinationHarborName',
            label: '目的港',
            width: '80'
          },
          {
            filed: 'qty',
            label: '件数',
            width: '80',
            isSort: true
          },
          {
            filed: 'weightKgs',
            label: '重量',
            width: '80',
            isSort: true
          },
          {
            filed: 'weightCbm',
            label: '材积',
            width: '80',
            isSort: true
          },
          {
            filed: 'consigneeName',
            label: '收件人',
            width: '80'
          },
          {
            filed: 'importerName',
            label: '进口商',
            width: '120'
          },
          {
            filed: 'saleName',
            label: '销售员',
            align: 'left',
            width: '180'
          },
          {
            filed: 'taxesAmount',
            label: '税金',
            width: '80',
            isSort: true
          },
          {
            filed: 'receivableAmount',
            label: '应收合计',
            width: '100',
            isSort: true
          },
          {
            filed: 'payableAmount',
            label: '应付合计',
            width: '100',
            isSort: true
          },
          {
            filed: 'reAmount',
            label: '利润合计',
            width: '100',
            formatter: (row) =>
              row.receivableAmount ? new Decimal(row.receivableAmount || 0).sub(new Decimal(row.payableAmount || 0)) + ' USD' : '0 USD',
            isSort: true
          },
          {
            filed: 'verifedAmount',
            label: '已核销金额',
            width: '100',
            isSort: true
          },
          {
            filed: 'unpaidAmount',
            label: '未付余额',
            width: '100',
            isSort: true
          }
          // {
          //   filed: 'pickUpTypeName',
          //   label: '提货方式',
          //   width: '140'
          // },
          // {
          //   filed: 'supplieName',
          //   label: '供应商',
          //   align: 'left',
          //   width: '160'
          // },
          // {
          //   filed: 'currency',
          //   label: '币制',
          //   width: '80'
          // },
          // {
          //   filed: 'invoiceAmount',
          //   label: '账单金额',
          //   width: '120',
          //   align: 'right',
          //   formatter: (row) => {
          //     return row.invoiceAmount
          //       ? row.invoiceAmount + ` ${row.currency}`
          //       : `0 ${row.currency}`
          //   }
          // },
          // {
          //   filed: 'createdName',
          //   label: '录入人',
          //   align: 'left',
          //   width: '80'
          // },
          // {
          //   filed: 'defrayStatusName',
          //   label: '申付状态',
          //   width: '120',
          //  isCustom: true
          // },
          // {
          //   filed: 'reviewOn',
          //   label: '创建日期',
          //   width: '100',
          //   align: 'left',
          //   formatter: (row) => {
          //     return row.createdOn
          //       ? row.createdOn.slice(0, row.createdOn.length - 9)
          //       : ''
          //   }
          // },
          // {
          //   filed: 'defrayDate',
          //   label: '申付日期',
          //   width: '100',
          //   align: 'left',
          //   formatter: (row) => {
          //     return row.defrayDate
          //       ? row.defrayDate.slice(0, row.defrayDate.length - 9)
          //       : ''
          //   }
          // },
        ],
        columns: [],
        total: 0,
        mutiCheck: true
      },
      loading: false,
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      height: 0,
      // filterList: {
      //   numbers: '',
      //   createDate: '',
      //   // invoiceDate: '',
      //   companyIds: [],
      //   supplierId: '',
      //   defrayStatus: 'All',
      //   saleIds: ''
      // },
      isActive: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      dialogVisible7: false,
      dialogVisible8: false,
      dialogVisible9: false,
      drawer: false,
      dialogType: 0,
      rowData: {},
      sortable: {},
      selectionItem: [],
      supplierOptions: [],
      userOptions: [],
      tabNumer: [],
      fileList: [],
      totalAmount: 0,
      tabTotal: 0,
      listTotal: 0,
      tabNumers: {},
      tabTotalAmount: {
        totalAmount: '',
        verifedAmount: ''
      },
      tabList: [
        { name: '账单列表', permissson: 'ZDLB', type: 10000 },
        // { name: '未录入', permissson: 'WLR', type: 0 },
        { name: '明细列表', permissson: 'MXLB', type: 0 }
      ], // tab按钮权限
      childTabList: [
        { name: '全部', type: 10000 },
        // { name: '未录入', permissson: 'WLR', type: 0 },
        { name: '未审核', type: 1 }, // type + 1
        { name: '已审核', type: 2 },
        { name: '已完成', type: 3 },
        { name: '部分核销', type: 11 },
        { name: '已核销', type: 4 }
      ],
      defrayStatusOptions: [
        {
          value: 'All',
          label: '全部'
        },
        {
          value: 0,
          label: '未申付'
        },
        {
          value: 1,
          label: '申付完成'
        }
      ],
      recognitionList: [
        'recognition'
      ], // 识别按钮的权限验证
      addNormalList: [
        'addNormal'
      ], // 新增一般账单
      deriveListA: ['derive'], // 导出按钮的权限验证
      addList: [
        'addShare_a',
        'addShare_b',
        'addShare_c',
        'addShare_d',
        'addShare_e'
      ], // 新增分摊账单
      referenceNumber: '',
      fileData: [],
      headers: { 'ESCLEARANCE': btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`) },
      activeCode: '',
      useFildList: [],
      useLogId: '',
      tableCode: 'Payable',
      tabCode: 'ZDLB',
      filterList: {},
      filterListJson: [],
      filterListId: '',
      destinationOptions: [],
      originOptions: [],
      pickUpOptions: [],
      clearenceOptions: []
    }
  },
  computed: {
    ...mapGetters(['companyDrapdown']),
    computedPermissions() {
      return function(key) {
        const menuList = this.$store.getters.initRouter
        const menu = permissions(this.$route.meta.code, menuList)
        const presentTab = menu.children.find(
          (a) => a.code === this.activeCode,
        )
        const code = presentTab?.children?.find((a) => a.nameCH === key)?.code
        return code || ''
      }
    },
    useFildListForTab() {
      const arr = this.useFildList.filter(
        (a) =>
          a.selected === true &&
          (a.tabCode === this.tabCode || a.tabCode === null),
      )
      if (arr.length > 0) {
        return arr
      } else {
        // 说明是新加的tab 页面 且 没有用户习惯
        return this.useFildList
      }
    },
    fileds() {
      const isCustomArr = ['blNo', 'status', 'clearenceType', 'pickUpType']
      const isSortArr = [
        'eta',
        'ata',
        'releaseDate',
        'emptyReturnedDate',
        'dischargeDate',
        'finishDate',
        'picPickUpDate',
        'firstDepartureDate',
        'qty',
        'weightCbm',
        'weightKgs',
        'taxesAmount',
        'receivableAmount',
        'payableAmount',
        'profitAmount',
        'verifedAmount',
        'unpaidAmount',
        'createdOn',
        'reviewOn',
        'completeOn'
      ]
      const isCopy = ['mblNo', 'blNo', 'containerNumber']
      const isAlign = ['mblNo', 'blNo']
      const formatter = {
        eta: (row) => {
          return row.eta ? row.eta.slice(0, row.eta.length - 9) : ''
        },
        ata: (row) => {
          return row.ata ? row.ata.slice(0, row.ata.length - 9) : ''
        },
        emptyReturnedDate: (row) => {
          return row.emptyReturnedDate
            ? row.emptyReturnedDate.slice(0, row.emptyReturnedDate.length - 9)
            : ''
        },
        releaseDate: (row) => {
          return row.releaseDate
            ? row.releaseDate.slice(0, row.releaseDate.length - 9)
            : ''
        },
        dischargeDate: (row) => {
          return row.dischargeDate
            ? row.dischargeDate.slice(0, row.dischargeDate.length - 9)
            : ''
        },
        finishDate: (row) => {
          return row.finishDate
            ? row.finishDate.slice(0, row.finishDate.length - 9)
            : ''
        },
        picPickUpDate: (row) => {
          return row.picPickUpDate
            ? row.picPickUpDate.slice(0, row.picPickUpDate.length - 9)
            : ''
        },
        firstDepartureDate: (row) => {
          return row.firstDepartureDate
            ? row.firstDepartureDate.slice(0, row.firstDepartureDate.length - 9)
            : ''
        },
        isHold: (row) => (row.isHold ? '是' : '否'),
        mblStatus: (row) => {
          const obj = {
            0: '未完结',
            1: '未完结',
            3: '已完结',
            4: '已完结'
          }
          return obj[row.mblStatus] || '未完结'
        },
        weightKgs: (row) => {
          return row.weightKgs ? row.weightKgs + ' KG' : '0 KG'
        },
        weightCbm: (row) => {
          return row.weightCbm ? row.weightCbm + ' CBM' : '0 CBM'
        },
        receivableAmount: (row) => {
          return row.receivableAmount ? row.receivableAmount + ' USD' : '0 USD'
        },
        payableAmount: (row) => {
          return row.payableAmount ? row.payableAmount + ' USD' : '0 USD'
        },
        profitAmount: (row) => {
          return (
            new Decimal(row.receivableAmount || 0)
              .sub(new Decimal(row.payableAmount || 0))
              .toNumber() + ' USD'
          )
        },
        verifedAmount: (row) => {
          return row.verifedAmount ? row.verifedAmount + ' USD' : '0 USD'
        },
        unpaidAmount: (row) => {
          return row.unpaidAmount ? row.unpaidAmount + ' USD' : '0 USD'
        }
      }
      const newArr = this.useFildListForTab.map((item) => {
        return {
          filed: item.filed,
          label: item.label,
          width: item.width,
          isSort: isSortArr.indexOf(item.filed) > -1, // 是否支持过滤
          align: isAlign.indexOf(item.filed) > -1 && 'left',
          fixed: item.isFixed, // 是否固定 true, left, right
          isCustom: isCustomArr.indexOf(item.filed) > -1, // 是否自定义列显示
          isCopy: isCopy.indexOf(item.filed) > -1,
          formatter: formatter[item.filed] || undefined
        }
      })
      newArr.unshift({
        filed: 'opt',
        label: '',
        width: '50px',
        fixed: 'left',
        isCustom: true
      })
      return newArr
    },
    // fileds() {
    //   // const arr = [
    //   //   {
    //   //     filed: 'statusName',
    //   //     label: '状态',
    //   //     width: '90',
    //   //     isCustom: true
    //   //   }
    //   // ]
    //   // const opt = {
    //   //   filed: 'opt',
    //   //   label: '操作',
    //   //   width: '150',
    //   //   fixed: 'right',
    //   //   isCustom: true
    //   // }
    //   // const defrayNumber = [
    //   //   {
    //   //     filed: 'defrayNumber',
    //   //     label: '申付单号',
    //   //     isCopy: true,
    //   //     width: '180'
    //   //   }
    //   // ]
    //   if (!this.active) {
    //     return [{
    //         filed: 'opt',
    //         label: '',
    //         width: '50px',
    //         isCustom: true,
    //         fixed: 'left'
    //       }, ...this.tableData.fileds]
    //   } else {
    //     const fileds = [
    //       {
    //         filed: 'companyName',
    //         label: '客户',
    //         width: '220',
    //         isSort: true,
    //         align: 'left'
    //       },
    //       {
    //         filed: 'mblNo',
    //         label: '提单号',
    //         width: '220',
    //         isSort: true,
    //         align: 'left'
    //       },
    //       {
    //         filed: 'blNo',
    //         label: '分单号',
    //         width: '220',
    //         isSort: true,
    //         isCustom: true,
    //         align: 'left'
    //       },
    //       {
    //         filed: 'invoiceTypeName',
    //         label: '类型',
    //         width: '160'
    //       },
    //       {
    //         filed: 'supplieName',
    //         label: '供应商',
    //         width: '90'
    //       },
    //       {
    //         filed: 'containerNumber',
    //         label: '柜号',
    //         width: '220',
    //         align: 'left'
    //       },
    //       {
    //         filed: 'feeName',
    //         label: '费用项',
    //         width: '220',
    //         isSort: true,
    //         align: 'left'
    //       },
    //       {
    //         filed: 'directCode',
    //         label: '直送仓库',
    //         width: '150'
    //       },
    //       {
    //         filed: 'isHold',
    //         label: '是否查验',
    //         width: '150',
    //         formatter: row => {
    //           return row.isHold ? '是' : '否'
    //         }
    //       },
    //       {
    //         filed: 'mblStatus',
    //         label: '提单状态',
    //         width: '150',
    //         formatter: (row) => {
    //           const obj = {
    //             0: '未完结',
    //             1: '未完结',
    //             3: '已完结',
    //             4: '已完结'
    //           }
    //           return obj[row.mblStatus] || '未完结'
    //         }
    //       },
    //       {
    //         filed: 'qty',
    //         label: '数量',
    //         width: '80',
    //         isSort: true
    //       },
    //       {
    //         filed: 'unitPrice',
    //         label: '单价',
    //         width: '100',
    //         isSort: true
    //       },
    //       {
    //         filed: 'totalAmount',
    //         label: '金额',
    //         width: '100',
    //         isSort: true
    //       },
    //       {
    //         filed: 'picPickUpDate',
    //         label: '提柜时间',
    //         width: '160',
    //         formatter: (row) =>
    //           row.picPickUpDate
    //             ? row.picPickUpDate.slice(0, row.picPickUpDate.length - 9)
    //             : ''
    //       },
    //       {
    //         filed: 'firstDepartureDate',
    //         label: '出库时间',
    //         width: '160',
    //         formatter: (row) =>
    //           row.firstDepartureDate
    //             ? row.firstDepartureDate.slice(0, row.firstDepartureDate.length - 9)
    //             : ''
    //       },
    //       {
    //         filed: 'supplierInvoiceDate',
    //         label: '账单日期',
    //         width: '180',
    //         isSort: true
    //       },
    //       {
    //         filed: 'remark',
    //         label: '备注',
    //         width: ''
    //       }
    //     ]
    //     if (+this.tabActive > 0) {
    //       fileds.push({
    //         filed: 'createdName',
    //         label: '录入人',
    //         width: '140'
    //       })
    //       fileds.push({
    //         filed: 'createdOn',
    //         label: '录入时间',
    //         width: '180',
    //         isSort: true
    //       })
    //       // {
    //       //   filed: 'reviewName',
    //       //   label: '审核人',
    //       //   width: '140'
    //       // },
    //       // {
    //       //   filed: 'reviewOn',
    //       //   label: '审核时间',
    //       //   width: '180'
    //       // }
    //     }
    //     if (+this.tabActive > 1) {
    //       fileds.push({
    //         filed: 'reviewName',
    //         label: '审核人',
    //         width: '140'
    //       })
    //       fileds.push({
    //         filed: 'reviewOn',
    //         label: '审核时间',
    //         width: '180',
    //         isSort: true
    //       })
    //     }
    //     if (+this.tabActive > 2) {
    //       fileds.push({
    //         filed: 'completeName',
    //         label: '完成人',
    //         width: '140'
    //       })
    //       fileds.push({
    //         filed: 'completeOn',
    //         label: '完成时间',
    //         width: '180',
    //         isSort: true
    //       })
    //     }
    //     if (+this.tabActive > 3) {
    //       fileds.push({
    //         filed: 'verifedAmount',
    //         label: '已核销金额',
    //         width: '100',
    //         isSort: true
    //       })
    //       fileds.push({
    //         filed: 'customerlnvoiceNumber',
    //         label: '账单号码',
    //         width: '200'
    //       })
    //     }
    //     return fileds
    //   }
    // },
    totalHtml() {
      const arr = []
      this.selectionItem.forEach((a) => {
        const item = arr.find((n) => n.currency === a.currency)
        if (!item) {
          arr.push({
            currency: a.currency,
            num: a.invoiceAmount
          })
        } else {
          item.num += +a.invoiceAmount
        }
      })
      let str = ' 账单金额：'
      arr.forEach((a, index) => {
        str += `<span style="color: #fe453d;font-weight: bold;line-height: 40px;${
          index > 0 ? 'margin-left: 10px' : ''
        }"> ${a.num.toFixed(2)}  ${a.currency}</span>`
      })
      return str
    }
  },
  created() {
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
    this.getUserList()
  },
  async mounted() {
    this.height = document.querySelector('.data').offsetHeight - 64
    if (!this.$store.state.connect.connect.tabCode) {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const codeList = ['ZDLB', 'MXLB']
      const childrenCode = menu.children.map((a) => a.code)
      this.active = codeList.findIndex((a) => childrenCode.includes(a))
      this.activeCode = menu.children[0].code
      // this.getList(this.pager)
      this.getUserUseLog()
      this.getCommData()
      this.getFilter()
    }
    if (!this.companyDrapdown.length) {
      await this.$store.dispatch('getCompanyDrapdown')
    }
    const pickUpOptions = await this.$store.dispatch(
      'getSupplierDropDownList',
      { scopValue: 19 }
    )
    this.pickUpOptions = pickUpOptions
    const clearenceOptions = await this.$store.dispatch(
      'getSupplierDropDownList',
      { scopValue: 18 }
    )
    this.clearenceOptions = clearenceOptions
    const destinationOptions = await this.$store.dispatch('getHarborDrapDown', {
      portType: 1,
      type: 1
    })
    this.destinationOptions = destinationOptions
    const originOptions = await this.$store.dispatch('getHarborDrapDown', {
      portType: 1,
      type: 0
    })
    this.originOptions = originOptions
  },
  methods: {
    async getUserUseLog() {
      try {
        this.loading = true
        // this.tableResData.columns = []
        const res = await getSysTableUser({
          tableCode: this.tableCode,
          tabCode: this.tabCode
        })
        if (res.success) {
          if (res.data && res.data.value) {
            await this.getList(this.pager)
            const filedArr = JSON.parse(res.data.value)
            this.useLogId = res.data.id
            this.useFildList = filedArr
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getFilter() {
      try {
        const res = await getSysTableUser({
          tableCode: this.tableCode,
          type: 1
        })
        if (res.success) {
          this.filterListJson = JSON.parse(res.data.value)
          this.filterListId = res.data.id
          console.log('filterListJson', this.filterListJson)
        }
      } catch (error) {
        console.warn(error)
      }
    },
    sortChange(orderObj) {
      this.sortable = {
        sortField: orderObj.prop,
        sortBy: orderObj.order === 'asc' ? 0 : 1
      }
      this.getList(this.pager)
    },
    getUserList() {
      getSaleList().then((res) => {
        if (res.success) {
          const arr = []
          res.data.map((item) => {
            arr.push({
              value: item.id,
              label: item.nameCH
            })
          })
          this.userOptions = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    getCommData() {
      getSupplierDropDownList({}).then((res) => {
        if (res.success) {
          const arr = res.data.map((a) => {
            return {
              label: `${a.code}-${a.wbName}-${a.name}`,
              value: a.id
            }
          })
          this.supplierOptions = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    changeType(type, code) {
      if (type) {
        this.height = document.querySelector('.data').offsetHeight - 103
        this.tabCode = 'MXLB'
      } else {
        this.height = document.querySelector('.data').offsetHeight - 64
        this.tabCode = 'ZDLB'
      }
      this.activeCode = code
      this.active = type
      const param = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.pager = param
      this.selectionItem = []
      this.getUserUseLog()
      // this.getList(param)
    },
    dblclick(row) {
      this.rowData = row
      if (this.active === 0) {
        this.dialogVisible4 = true
      }
    },
    async getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.sortable,
            ...this.formatterFilter(),
                    status:
          this.active === 0 || this.tabActive === 10000
            ? undefined
            : +this.tabActive - 1
          }
        }
        let res
        if (this.active === 0) {
          res = await getPayablePages(params)
        } else {
          res = await getPayablePages1(params)
        }
        if (res.success) {
          this.loading = false
          this.tableData.columns = res.data.list
          this.tableData.total = res.data.total
          if (this.active === 0) {
            this.listTotal = res.data.tabTotal
          } else {
            this.tabNumer = res.data.tabNumer
            this.tabTotal = res.data.tabTotal
            this.tabTotalAmount = {
              totalAmount: res.data.totalAmount,
              verifedAmount: res.data.verifedAmount
            }
          }
          res.data.totalAmount && (this.totalAmount = res.data.totalAmount)
        } else {
          this.loading = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    formatterFilter() {
      return this.filterList
      // return {
      //   status: this.active === 0 || this.tabActive === 10000 ? undefined : +this.tabActive - 1,
      //   companyIds:
      //     this.filterList.companyIds.length !== 0
      //       ? this.filterList.companyIds
      //       : undefined,
      //   numbers:
      //     this.filterList.numbers.length > 0
      //       ? this.filterList.numbers
      //       : undefined,
      //   saleIds:
      //     this.filterList.saleIds.length > 0
      //       ? this.filterList.saleIds
      //       : undefined,
      //   supplierId:
      //     this.filterList.supplierId !== '' && this.filterList.supplierId.length > 0
      //       ? this.filterList.supplierId
      //       : undefined,
      //   createBeginDate:
      //     this.filterList.date !== ''
      //       ? this.filterList.createDate[0]
      //       : undefined,
      //   createEndDate:
      //     this.filterList.date !== ''
      //       ? this.filterList.createDate[1]
      //       : undefined,
      //   defrayStatus:
      //     this.filterList.defrayStatus !== 'All'
      //       ? this.filterList.defrayStatus
      //       : undefined
      // }
    },
    initList() {
      const param = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = param
      this.getList(param)
    },
    sendFilter() {
      const filterList = this.$refs.selectFilter.getData()
      if (Object.keys(filterList).length > 0) {
        this.isActive = true
      }
      this.filterList = filterList
      // this.initList()
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = params
      this.referenceNumber = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.getList(params)
      // if (
      //   this.filterList.createDate !== '' ||
      //   this.filterList.supplierId !== 'All' ||
      //   this.filterList.numbers.length !== 0 ||
      //   this.filterList.saleIds.length !== 0 ||
      //   this.filterList.saleIds.length !== 0 ||
      //   this.filterList.companyIds.length !== 0 ||
      //   this.filterList.defrayStatus !== 'All'
      // ) {
      //   this.isActive = true
      // } else {
      //   this.isActive = false
      // }
      // const params = {
      //   pageIndex: 1,
      //   pageSize: 20
      // }
      // this.pager = params
      // this.getList(params)
    },
    reset() {
      this.$refs.selectFilter.reset()
      this.isActive = false
      this.referenceNumber = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      // this.filterList = {
      //   numbers: '',
      //   createDate: '',
      //   supplierId: '',
      //   invoiceDate: '',
      //   saleIds: '',
      //   companyIds: [],
      //   defrayStatus: 'All'
      // }
      // this.$refs.baseMutiInput.reset()
      // this.isActive = false
    },
    handlePageChange(page) {
      this.pager = page
      this.getList(page)
    },
    handleSelectionChange(items) {
      this.selectionItem = items
    },
    // 详情
    detail(row) {
      this.rowData = row
      this.dialogVisible4 = true
    },
    // 审核
    async audit(row) {
      try {
        const result = await reviewedPayableInvoice({ id: row.id })
        if (result.success) {
          this.getList(this.pager)
          this.$message.success(result.errorMessage)
        } else {
          this.$message.error(result.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    // 反审核
    counteraudit() {
      if (this.selectionItem.length === 0) {
        this.$message.error('请选择要删除的记录')
        return
      }
      this.$confirm('是否确定要进行反审核？', '反审核提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      })
        .then(async() => {
          try {
            const id = this.selectionItem.map((item) => item.id)
            const result = await batchRepeatReviewedPayable({ ids: id, completed: true })
            if (result.success) {
              this.getList(this.pager)
              this.$message.success(result.errorMessage)
            } else {
              this.$message.error(result.errorMessage)
            }
          } catch (error) {
            console.error(error)
          }
        })
        .catch(() => {})
    },
    // 删除
    async batchDeleteRow() {
      if (this.selectionItem.length === 0) {
        this.$message.error('请选择要删除的记录')
        return
      }
      this.$confirm('要删除的记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          const id = this.selectionItem.map((item) => item.id)
          const res = await deletePayable({ ids: id, completed: true })
          if (res.success) {
            this.getList(this.pager)
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.errorMessage)
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
    async ok() {
      this.dialogVisible1 = false
      this.dialogVisible3 = false
      this.initList()
      try {
        const params = {
          ...this.pager,
          queryParam: {
            status: 0
          }
        }
        const res = await getPayablePages(params)
        if (res.success) {
          this.detail(res.data.list[0])
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    ok2(isStep) {
      this.dialogVisible4 = false
      if (isStep) {
        this.active = 3
      }
      this.getList(this.pager)
    },
    async handleBatch() {
      if (!this.selectionItem.length) {
        this.$message.warning('未勾选账单')
        return
      }
      try {
        const ids = this.selectionItem.map(a => a.id)
        const res = await reviewedPayable({ ids, completed: true })
        if (res.success) {
          this.$message.success('审核成功')
          this.getList(this.pager)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    closeSearchPanel() {
      this.handleConfirm()
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
      if (this.referenceNumber && this.referenceNumber !== '') {
        this.filterList.numbers = this.referenceNumber
      }
      this.$refs.popover.doClose()
      const param = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pagerConfig = param
      this.getList(param)
    }, 0)
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.filterList.numbers = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.initList()
    },
    async batchCounterAudit(completed = false) {
      if (!this.selectionItem.length) {
        this.$message.warning('未勾选账单')
        return
      }
      try {
        const ids = this.selectionItem.map(a => a.id)
        const res = await completePayable({ ids, completed })
        if (res.success) {
          this.$message.success('反审核成功')
          this.getList(this.pager)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 跟进记录
    viewlog(row) {
      this.drawer = true
      this.rowData = row
    },
    donwloadFile() {
      const elink = document.createElement('a')
      elink.style.display = 'none'
      const guid = '0016ed8d2ad64a57b63afd9e017e8afb'
      elink.href = `/api/SystemFile/downLoadTemplate?guid=${guid}`
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    },
    handleError(error) {
      this.$message.error(error)
      this.fileList = []
    },
    handleSuccess(res) {
      if (res.success) {
        this.fileList = []
        this.$message.success('导入成功')
        this.fileData = res.data
        this.dialogVisible7 = true
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 导出
   async exportOrigin() {
      const params = {
        ...this.formatterFilter(),
                    status:
          this.active === 0 || this.tabActive === 10000
            ? undefined
            : +this.tabActive - 1,
        ids: this.selectionItem.map((item) => item.id)
      }
      this.loading = true
      if (!this.active) {
        await derive('Payable/exportPayableSummary', 'post', params)
      } else {
        await derive('Payable/exportPayable', 'post', params)
      }
      this.loading = false
    }
    // 导出
    // derive() {
    //   const params = {
    //     ...this.formatterFilter()
    //   }
    //   derive('Payable/exportPayable', 'post', params)
    // }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }
    .active {
      color:  rgb(18,88,188);
    }
  }
  .opt {
    display: flex;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    .search {
      position: relative;
      display: flex;
      width: 200px;
      margin-right: 5px;
      color: #2c3e50;
      .searchPop {
        /deep/ .el-popover {
          z-index: 9999;
          right: 0;
        }
        .close {
          position: absolute;
          top: 6px;
          right: 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      .input-search {
        width: 166px;
        height: 30px !important;
        /deep/ .el-input__inner {
          height: 30px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
    .recognition {
      width: 160px;
      border: 1px solid #35ba83;
      color: #35ba83;
      margin-right: 5px;
      height: 30px;
      box-sizing: border-box;
      border-radius: 4px;
      cursor: pointer;
    }
    .import {
      width: 80px;
      background: #35ba83;
      color: #ffffff;
      margin-right: 5px;
      height: 30px;
      box-sizing: border-box;
      border-radius: 4px;
      cursor: pointer;
    }
    .derive_a {
      min-width: 80px;
      background:  rgb(18,88,188);
      margin-right: 5px;
      height: 30px;
      box-sizing: border-box;
      border-radius: 4px;
      cursor: pointer;
    }
    .add {
      width: 120px;
      background:  rgb(18,88,188);
      margin-right: 5px;
      height: 30px;
      box-sizing: border-box;
      border-radius: 4px;
      cursor: pointer;
    }
    .derive_b {
      width: 120px;
      border: 1px solid  rgb(18,88,188);
      color:  rgb(18,88,188);
      height: 30px;
      box-sizing: border-box;
      border-radius: 4px;
      cursor: pointer;
    }
    .status {
      width: 60px;
      height: 26px;
      border-radius: 4px 4px 4px 4px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
    }
  }
  .data {
    width: 100%;
    height: calc(100% - 50px);
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
    .status {
      display: inline-block;
      width: auto;
      padding: 0 12px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      border-radius: 4px 4px 4px 4px;
    }
    .status1 {
      color: #feaa4f;
      background: rgba(254, 170, 79, 0.1);
    }
    .status2 {
      color: #ff7444;
      background: rgba(255, 116, 68, 0.1);
    }
    .status3 {
      color: #35ba83;
      background: rgba(53, 186, 131, 0.1);
    }
  }
  .clearenceType {
    display: inline-block;
    padding: 4px 12px;
    width: 36px;
    height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    border-radius: 4px;
  }
  .clearenceType0 {
    color: #35ba83;
    background: rgba(53, 186, 131, 0.1);
  }
  .clearenceType1 {
    color: #9d67fe;
    background: rgba(157, 103, 254, 0.1);
  }
  .pickUpType {
    display: inline-block;
    padding: 4px 12px;
    height: 16px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    line-height: 16px;
    border-radius: 4px;
  }
  .pickUpType0 {
    color:  rgb(18,88,188);
    background: rgba(35, 149, 243, 0.1);
  }
  .pickUpType1 {

    color: rgb(157, 103, 254);
    background: rgba(157, 103, 254, 0.1);
  }
  .pickUpType2 {
    color: #feaa4f;
    background: rgba(254, 170, 79, 0.1);
  }
  .custom-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;
    position: absolute;
    height: 40px;
    background: #f7f7f7;
    border: 1px solid #eeeeee;
    border-top: 0;
    padding-left: 17px;
    padding-right: 40px;
    box-sizing: border-box;z-index: 2 ;
    .select {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 40px;
    }
    .total {
      margin-left: 16px;
      font-size: 14px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      color: #333333;
      line-height: 40px;
      span {
        color: #fe453d;
        font-weight: bold;
        line-height: 40px;
      }
    }
    .btn-bol {
      width: 80px;
      height: 30px;
      background: #ffffff;
      border-radius: 2px 2px 2px 2px;
      border: 1px solid  rgb(18,88,188);
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color:  rgb(18,88,188);
      line-height: 30px;
      text-align: center;
      margin-left: 5px;
      margin-top: 5px;
      cursor: pointer;
    }
    .batchCounterAudit {
      width: 120px;
      height: 30px;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #33C481;
      cursor: pointer;
      box-sizing: border-box;
      margin-left: 5px;
      margin-top: 5px;
      border-radius: 2px 2px 2px 2px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 14px;
      color: #33C481;
    }
  }
  .table-opt {
    display: flex;
    justify-content: space-around;
    span {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color:  rgb(18,88,188);
      cursor: pointer;
      & + span {
        margin-left: 20px;
      }
    }
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #FFF;
  border: 1px solid #DCDFE6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
  margin-left: 10px
}
</style>
<style lang="less">

.filter-detail {
  width: 100px;
  height: 40px;
  background: #35BA83;
  border-radius: 4px 4px 4px 4px;
  font-size: 14px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  cursor: pointer;
  margin-left: 15px;
}
</style>
